{
  class CrumbsController {
    constructor($state, $stateParams) {
      'ngInject';

      if (!$state.current.crumbs) {
        throw new Error('CRUMBS - Requires a crumbs array definition on the state object');
      }

      this.crumbs = angular.copy($state.current.crumbs);
      this.params = $stateParams;
      this.crumbs.forEach(crumb => {
        for (const key in this.params) {
          crumb.title = crumb.title.replace(`:${key}`, this.params[key]);
        }
      });
    }

  }

  CrumbsController.$inject = ["$state", "$stateParams"];
  angular.module('pims').component('crumbs', {
    template: `
      <ul id="crumbs">
        <li ng-repeat="crumb in $ctrl.crumbs", ng-class="{'crumb-last': $last}">
          <a class="crumb-link" ng-if="crumb.state", ng-bind="crumb.title", ui-sref="{{crumb.state}}($ctrl.params)"></a>
          <a class="crumb-current", ng-if="$last", ng-bind="crumb.title"></a>
        </li>
      </ul>
    `,
    controller: CrumbsController
  });
}